import { render, staticRenderFns } from "./el-competition-info.vue?vue&type=template&id=4cab8833&lang=pug"
import script from "./el-competition-info.vue?vue&type=script&lang=js"
export * from "./el-competition-info.vue?vue&type=script&lang=js"
import style0 from "./el-competition-info.vue?vue&type=style&index=0&id=4cab8833&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports